<template>
    <div class="component-wrap" data-app="true">
        <Header-menu />
        <div class="wrapper">
            <User-menu />
            <v-layout column :class="{'pa-4' : $vuetify.breakpoint.smAndUp}">
                <v-breadcrumbs class=" pl-0" :class="{'mx-3': $vuetify.breakpoint.smAndDown}">
                    <v-icon slot="divider" aria-hidden="true" translate="no">keyboard_arrow_left</v-icon>
                    <router-link to="/">
                        <v-breadcrumbs-item>
                            <v-icon class="mr-1" aria-hidden="true" translate="no">keyboard_arrow_left</v-icon> {{ $t("Главная") }}
                        </v-breadcrumbs-item>
                    </router-link>
                </v-breadcrumbs>
                <Mainpage />
            </v-layout>

        </div>
        <FooterBlock />
    </div>
</template>

<script>
import Mainpage from '../components/view_blocks/News_main/news_page';
import HeaderMenu    from '@/components/blocks/common/Header_menu.vue';
import UserMenu      from '@/components/blocks/common/User_menu.vue';
import FooterBlock   from '@/components/blocks/common/Footer.vue';
import {mapGetters} from 'vuex';
export default {
  components: {
    Mainpage, HeaderMenu, UserMenu, FooterBlock,
  },
  computed: {
    ...mapGetters('profile/breadcrumbs', [
      'breadcrumbs',
    ]),
  },
};
</script>
